// CONTENT.IQ — inline SVG icon set (stroke: currentColor, fill: none)

export const CiqIcon = {
  mic: (
    <svg viewBox="0 0 24 24">
      <rect x="9" y="3" width="6" height="12" rx="3" />
      <path d="M5 11a7 7 0 0 0 14 0" />
      <path d="M12 18v3" />
    </svg>
  ),
  micOff: (
    <svg viewBox="0 0 24 24">
      <path d="M3 3l18 18" />
      <path d="M9 9v3a3 3 0 0 0 5.1 2.1" />
      <path d="M15 9V6a3 3 0 0 0-6 0" />
      <path d="M5 11a7 7 0 0 0 11.5 5.4" />
      <path d="M19 11a7 7 0 0 1-1.5 4.3" />
    </svg>
  ),
  speaker: (
    <svg viewBox="0 0 24 24">
      <path d="M5 9h3l5-4v14l-5-4H5z" />
      <path d="M16 8a5 5 0 0 1 0 8" />
      <path d="M19 5a9 9 0 0 1 0 14" />
    </svg>
  ),
  send: (
    <svg viewBox="0 0 24 24">
      <path d="M4 12l16-7-7 16-2-7z" />
    </svg>
  ),
  sparkle: (
    <svg viewBox="0 0 24 24">
      <path d="M12 5l1.8 5.2L19 12l-5.2 1.8L12 19l-1.8-5.2L5 12l5.2-1.8z" />
      <path d="M19 3l.8 2L22 6l-2.2.8L19 9l-.8-2.2L16 6l2.2-.8z" />
    </svg>
  ),
  bolt: (
    <svg viewBox="0 0 24 24">
      <path d="M13 3L4 14h7l-1 7 9-11h-7z" />
    </svg>
  ),
  blog: (
    <svg viewBox="0 0 24 24">
      <rect x="4" y="4" width="16" height="16" rx="2" />
      <path d="M8 9h8M8 13h8M8 17h5" />
    </svg>
  ),
  linkedin: (
    <svg viewBox="0 0 24 24">
      <rect x="3" y="3" width="18" height="18" rx="3" />
      <path d="M8 10v7M8 7v.01M12 17v-4a2 2 0 0 1 4 0v4M12 10v7" />
    </svg>
  ),
  email: (
    <svg viewBox="0 0 24 24">
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M3 7l9 6 9-6" />
    </svg>
  ),
  twitter: (
    <svg viewBox="0 0 24 24">
      <path d="M4 4l7.5 9L4.5 20H7l6-6 4.5 6H20l-7.8-10L19.5 4H17l-5.2 5.2L8 4z" />
    </svg>
  ),
  insta: (
    <svg viewBox="0 0 24 24">
      <rect x="3" y="3" width="18" height="18" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.5" cy="6.5" r="1" fill="currentColor" />
    </svg>
  ),
  yt: (
    <svg viewBox="0 0 24 24">
      <rect x="2" y="6" width="20" height="12" rx="3" />
      <path d="M10 9.5l5 2.5-5 2.5z" fill="currentColor" />
    </svg>
  ),
  product: (
    <svg viewBox="0 0 24 24">
      <path d="M3 7l9-4 9 4-9 4z" />
      <path d="M3 7v10l9 4 9-4V7" />
      <path d="M12 11v10" />
    </svg>
  ),
  pitch: (
    <svg viewBox="0 0 24 24">
      <path d="M3 3v18h18" />
      <path d="M7 15l4-4 3 3 6-7" />
    </svg>
  ),
  bio: (
    <svg viewBox="0 0 24 24">
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21a8 8 0 0 1 16 0" />
    </svg>
  ),
  press: (
    <svg viewBox="0 0 24 24">
      <rect x="3" y="5" width="14" height="14" rx="2" />
      <path d="M17 9h4v8a2 2 0 0 1-4 0V9z" />
      <path d="M7 9h6M7 13h6M7 17h4" />
    </svg>
  ),
  history: (
    <svg viewBox="0 0 24 24">
      <path d="M3 12a9 9 0 1 0 3-6.7" />
      <path d="M3 4v5h5" />
      <path d="M12 8v5l3 2" />
    </svg>
  ),
  star: (
    <svg viewBox="0 0 24 24">
      <path d="M12 3l2.7 5.5 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.8 1-6.1L3.2 9.4l6.1-.9z" />
    </svg>
  ),
  starFilled: (
    <svg viewBox="0 0 24 24">
      <path
        d="M12 3l2.7 5.5 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.8 1-6.1L3.2 9.4l6.1-.9z"
        fill="currentColor"
        stroke="none"
      />
    </svg>
  ),
  gear: (
    <svg viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="3" />
      <path d="M19 12a7 7 0 0 0-.1-1.2l2-1.5-2-3.4-2.4.8a7 7 0 0 0-2-1.2L14 3h-4l-.5 2.5a7 7 0 0 0-2 1.2l-2.4-.8-2 3.4 2 1.5a7 7 0 0 0 0 2.4l-2 1.5 2 3.4 2.4-.8a7 7 0 0 0 2 1.2L10 21h4l.5-2.5a7 7 0 0 0 2-1.2l2.4.8 2-3.4-2-1.5c.1-.4.1-.8.1-1.2z" />
    </svg>
  ),
  templ: (
    <svg viewBox="0 0 24 24">
      <rect x="3" y="3" width="18" height="6" rx="1" />
      <rect x="3" y="11" width="8" height="10" rx="1" />
      <rect x="13" y="11" width="8" height="10" rx="1" />
    </svg>
  ),
  dash: (
    <svg viewBox="0 0 24 24">
      <rect x="3" y="3" width="8" height="8" rx="1" />
      <rect x="13" y="3" width="8" height="5" rx="1" />
      <rect x="13" y="10" width="8" height="11" rx="1" />
      <rect x="3" y="13" width="8" height="8" rx="1" />
    </svg>
  ),
  copy: (
    <svg viewBox="0 0 24 24">
      <rect x="8" y="8" width="12" height="12" rx="2" />
      <path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2" />
    </svg>
  ),
  download: (
    <svg viewBox="0 0 24 24">
      <path d="M12 4v12" />
      <path d="M7 11l5 5 5-5" />
      <path d="M4 20h16" />
    </svg>
  ),
  search: (
    <svg viewBox="0 0 24 24">
      <circle cx="11" cy="11" r="7" />
      <path d="M21 21l-4.5-4.5" />
    </svg>
  ),
  plus: (
    <svg viewBox="0 0 24 24">
      <path d="M12 5v14M5 12h14" />
    </svg>
  ),
  check: (
    <svg viewBox="0 0 24 24">
      <path d="M5 12l5 5L20 7" />
    </svg>
  ),
  arrow: (
    <svg viewBox="0 0 24 24">
      <path d="M5 12h14M13 6l6 6-6 6" />
    </svg>
  ),
  chevR: (
    <svg viewBox="0 0 24 24">
      <path d="M9 6l6 6-6 6" />
    </svg>
  ),
  chevD: (
    <svg viewBox="0 0 24 24">
      <path d="M6 9l6 6 6-6" />
    </svg>
  ),
  chevL: (
    <svg viewBox="0 0 24 24">
      <path d="M15 6l-6 6 6 6" />
    </svg>
  ),
  logout: (
    <svg viewBox="0 0 24 24">
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <path d="M16 17l5-5-5-5" />
      <path d="M21 12H9" />
    </svg>
  ),
  user: (
    <svg viewBox="0 0 24 24">
      <circle cx="12" cy="9" r="4" />
      <path d="M4 21a8 8 0 0 1 16 0" />
    </svg>
  ),
  globe: (
    <svg viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" />
    </svg>
  ),
  pause: (
    <svg viewBox="0 0 24 24">
      <rect x="6" y="5" width="4" height="14" rx="1" />
      <rect x="14" y="5" width="4" height="14" rx="1" />
    </svg>
  ),
  play: (
    <svg viewBox="0 0 24 24">
      <path d="M7 5l12 7-12 7z" />
    </svg>
  ),
  stop: (
    <svg viewBox="0 0 24 24">
      <rect x="6" y="6" width="12" height="12" rx="2" />
    </svg>
  ),
  refresh: (
    <svg viewBox="0 0 24 24">
      <path d="M3 12a9 9 0 0 1 15-6.7L21 8" />
      <path d="M21 3v5h-5" />
      <path d="M21 12a9 9 0 0 1-15 6.7L3 16" />
      <path d="M3 21v-5h5" />
    </svg>
  ),
  brain: (
    <svg viewBox="0 0 24 24">
      <path d="M9 4a3 3 0 0 0-3 3v1a3 3 0 0 0-2 5 3 3 0 0 0 2 5v1a3 3 0 0 0 6 0V4a3 3 0 0 0-3 0z" />
      <path d="M15 4a3 3 0 0 1 3 3v1a3 3 0 0 1 2 5 3 3 0 0 1-2 5v1a3 3 0 0 1-6 0" />
    </svg>
  ),
  x: (
    <svg viewBox="0 0 24 24">
      <path d="M5 5l14 14M19 5L5 19" />
    </svg>
  ),
  edit: (
    <svg viewBox="0 0 24 24">
      <path
        d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  trash: (
    <svg viewBox="0 0 24 24">
      <path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10 11v6M14 11v6" strokeLinecap="round" />
    </svg>
  ),
  filter: (
    <svg viewBox="0 0 24 24">
      <path d="M3 5h18l-7 9v6l-4-2v-4z" />
    </svg>
  ),
  tag: (
    <svg viewBox="0 0 24 24">
      <path d="M3 12V3h9l9 9-9 9z" />
      <circle cx="8" cy="8" r="1.5" fill="currentColor" />
    </svg>
  ),
  flame: (
    <svg viewBox="0 0 24 24">
      <path d="M12 3s5 4 5 9a5 5 0 0 1-10 0c0-2 1-3 2-4 0 2 1 3 2 3 0-3 1-6 1-8z" />
    </svg>
  ),
  sun: (
    <svg viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v3M12 19v3M2 12h3M19 12h3M5 5l2 2M17 17l2 2M5 19l2-2M17 7l2-2" />
    </svg>
  ),
  moon: (
    <svg viewBox="0 0 24 24">
      <path d="M20 14a8 8 0 1 1-10-10 7 7 0 0 0 10 10z" />
    </svg>
  ),
  card: (
    <svg viewBox="0 0 24 24">
      <rect x="3" y="6" width="18" height="13" rx="2" />
      <path d="M3 10h18M7 15h3" />
    </svg>
  ),
  zap: (
    <svg viewBox="0 0 24 24">
      <path d="M13 2L3 14h7l-1 8 11-13h-7z" />
    </svg>
  ),
  info: (
    <svg viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="10" />
      <path d="M12 16v-4M12 8h.01" strokeLinecap="round" />
    </svg>
  ),
  shield: (
    <svg viewBox="0 0 24 24">
      <path d="M12 3l8 4v5c0 5-4 9-8 10-4-1-8-5-8-10V7z" />
    </svg>
  ),
  bell: (
    <svg viewBox="0 0 24 24">
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
      <path d="M13.73 21a2 2 0 0 1-3.46 0" />
    </svg>
  ),
  google: (
    <svg viewBox="0 0 24 24" fill="none">
      <path
        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
        fill="#4285F4"
      />
      <path
        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
        fill="#34A853"
      />
      <path
        d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
        fill="#FBBC05"
      />
      <path
        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
        fill="#EA4335"
      />
    </svg>
  ),
};

export function Ico({
  icon,
  size = 16,
  style,
  className,
}: {
  icon: React.ReactNode;
  size?: number;
  style?: React.CSSProperties;
  className?: string;
}) {
  return (
    <span
      className={`ico${className ? ` ${className}` : ""}`}
      style={{ width: size, height: size, ...style }}
    >
      {icon}
    </span>
  );
}

export function MicWave({
  size = "md",
  color,
  listening = true,
}: {
  size?: "sm" | "md" | "lg";
  color?: string;
  listening?: boolean;
}) {
  const heights =
    size === "lg"
      ? [30, 60, 90, 50, 100, 70, 35]
      : size === "sm"
        ? [30, 60, 80, 50, 90, 55, 40]
        : [30, 70, 100, 60, 85, 40, 55];
  const widthMap = { sm: 2, md: 3, lg: 4 };
  const heightMap = { sm: 14, md: 22, lg: 36 };
  return (
    <span
      className={`wave${listening ? "" : " static"}`}
      style={{ color: color ?? "currentColor", height: heightMap[size] }}
    >
      {heights.map((h, i) => (
        <i key={i} style={{ width: widthMap[size], height: `${h}%` }} />
      ))}
    </span>
  );
}
